import { render, staticRenderFns } from "./HomeworkManage.vue?vue&type=template&id=3dff1772&"
import script from "./HomeworkManage.vue?vue&type=script&lang=js&"
export * from "./HomeworkManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports